import React from "react";
import { useTranslation } from "react-i18next";
import { StyledP } from "base/BaseStyle";
import {
  ACCESS_STATUS,
  DEFAULT_STATUS,
  STOCK_STATUS,
  USER_BLACKLIST_STATUS,
} from "constants/base";
import { TagContainer } from "./StatusTag.styles";

function StatusTag({ status, i18nModule }) {
  const { t } = useTranslation();

  if (!status) {
    return <StyledP>-</StyledP>;
  }

  const i18nStatus = i18nModule
    ? t(`${i18nModule}.${status}`)
    : t(`Status.${status}`);

  switch (status) {
    case DEFAULT_STATUS.CLEARED:
    case DEFAULT_STATUS.APPROVE:
    case DEFAULT_STATUS.CONFIRMED: {
      return <TagContainer $bgColor="primary">{i18nStatus}</TagContainer>;
    }
    case USER_BLACKLIST_STATUS.BLACKLISTED:
    case DEFAULT_STATUS.APPROVED:
    case DEFAULT_STATUS.ACTIVE:
    case DEFAULT_STATUS.SUCCESS:
    case DEFAULT_STATUS.COMPLETED:
    case DEFAULT_STATUS.DELIVERED:
    case ACCESS_STATUS.UNBLOCKED:
    case STOCK_STATUS.IN_STOCK: {
      return <TagContainer $bgColor="success">{i18nStatus}</TagContainer>;
    }
    case DEFAULT_STATUS.ERROR:
    case DEFAULT_STATUS.FAILED:
    case DEFAULT_STATUS.REJECT:
    case DEFAULT_STATUS.REJECTED:
    case DEFAULT_STATUS.FAIL:
    case DEFAULT_STATUS.CANCELLED:
    case DEFAULT_STATUS.INACTIVE:
    case DEFAULT_STATUS.SUSPENDED:
    case DEFAULT_STATUS.TAKEN_DOWN:
    case ACCESS_STATUS.BLOCKED:
    case STOCK_STATUS.OUT_OF_STOCK: {
      return <TagContainer $bgColor="danger">{i18nStatus}</TagContainer>;
    }
    case DEFAULT_STATUS.PENDING_TO_VOID:
    case DEFAULT_STATUS.PROCESSING:
    case STOCK_STATUS.LOW_STOCK: {
      return <TagContainer $bgColor="warning">{i18nStatus}</TagContainer>;
    }
    case USER_BLACKLIST_STATUS.REMOVED:
    case DEFAULT_STATUS.VOIDED:
    case DEFAULT_STATUS.SUBMITTED:
    case DEFAULT_STATUS.PENDING_APPROVAL:
    case DEFAULT_STATUS.PENDING: {
      return <TagContainer $bgColor="gray">{i18nStatus}</TagContainer>;
    }
    default: {
      return <span>{i18nStatus}</span>;
    }
  }
}

export default StatusTag;
